import { render } from "./FloorGuide.vue?vue&type=template&id=2464e771"
import script from "./FloorGuide.vue?vue&type=script&lang=js"
export * from "./FloorGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__